import "../../../../styles/workspace_styles/CustomerAdministratorStyles/Accounts/BillingAccount.css";
const BillingAccount = () =>{
    return(
        <div className="customer-administrator-account-billing-account-container">
            <p>You currently do not have a billing account.</p>
        </div>
    );
};
export default BillingAccount;